import { createProfessionalExporter } from '../../utils/professionalExport';
import { formatGymPrice } from '../../utils/gymMoney';
import { saleRowDuration, saleRowPackageName } from './sales/salePeriodUtils';

const headers = [
  'ID',
  'CR. No.',
  'Serial No',
  'Member',
  'Package',
  'Duration',
  'Amount',
  'Pending Amount',
  'Method',
  'Date',
  'Status',
];

const exporter = createProfessionalExporter({
  title: 'Payment Report',
  headers,
  slug: 'payments',
  documentType: 'invoice',
  getRows: (list) =>
    list.map((p) => [
      p.id,
      p.invoiceId || '—',
      p.gymId || '—',
      p.member,
      saleRowPackageName(p),
      saleRowDuration(p),
      formatGymPrice(p.amount),
      formatGymPrice(p.pendingAmount || 0),
      p.method,
      p.date,
      p.status === 'completed' ? 'Completed' : 'Pending',
    ]),
  getSummary: (list) => {
    const total = list.reduce((sum, p) => sum + Number(p.amount || 0), 0);
    const pending = list.reduce((sum, p) => sum + Number(p.pendingAmount || 0), 0);
    return [
      `Total payments: ${list.length}`,
      `Completed: ${list.filter((p) => p.status === 'completed').length}`,
      `Total amount: ${formatGymPrice(total)}`,
      `Total pending: ${formatGymPrice(pending)}`,
    ];
  },
});

export const printPaymentList = (data) => exporter.print(data);
export const exportPaymentCsv = (data) => exporter.csv(data);
export const exportPaymentExcel = (data) => exporter.excel(data);
export const exportPaymentPdf = (data) => exporter.pdf(data);
export const exportPayments = (data) => exporter.export(data);
